module.exports = __webpack_public_path__ + "static/img/wzry-companyStructure.f9b6479b.png";